import React from "react";
import Button from "../atoms/Button.jsx";
import Select from "../atoms/Select.jsx";

const FilterSelects = ({
  cloudValue,
  onCloudChange,
  statusValue,
  onStatusChange,
  onClear,
  providerOptions = [],
  className = "",
}) => (
  <>
    <div className="flex flex-col h-full justify-end">
      <label
        htmlFor="cloud"
        className="block text-sm font-medium text-gray-700 mb-2"
      >
        Cloud Provider
      </label>
      <Select
        id="cloud"
        value={cloudValue || ""}
        onChange={onCloudChange}
        className="w-full text-sm bg-white border-gray-300 focus:ring-blue-500 focus:border-blue-500"
      >
        <option value="">All providers</option>
        {providerOptions.map(provider => (
          <option key={provider} value={provider}>
            {provider}
          </option>
        ))}
      </Select>
    </div>
    <div className="flex flex-col h-full justify-end">
      <label
        htmlFor="status"
        className="block text-sm font-medium text-gray-700 mb-2"
      >
        Status
      </label>
      <Select
        id="status"
        value={statusValue || ""}
        onChange={onStatusChange}
        className="w-full text-sm bg-white border-gray-300 focus:ring-blue-500 focus:border-blue-500"
      >
        <option value="">All statuses</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
      </Select>
    </div>
    <div className="flex flex-col h-full justify-end">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        &nbsp;
      </label>
      <Button
        onClick={onClear}
        variant="secondary"
        className="w-full text-sm font-medium text-gray-700 bg-gray-50 border border-gray-300 hover:bg-gray-100 focus:ring-gray-500 cursor-pointer"
      >
        Clear filters
      </Button>
    </div>
  </>
);

export default FilterSelects;
